var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#686868"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10568 15.5C7.83888 15.5 7.58542 15.3884 7.39867 15.1931L3.6234 11.2447C3.23654 10.8401 3.23654 10.1704 3.6234 9.76578C4.01025 9.36118 4.65057 9.36118 5.03743 9.76578L8.10568 12.9747L14.9624 5.80345C15.3493 5.39885 15.9896 5.39885 16.3764 5.80345C16.7633 6.20806 16.7633 6.87775 16.3764 7.28235L8.8127 15.1931C8.62594 15.3884 8.37248 15.5 8.10568 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDisabled);
export default __webpack_public_path__ + "static/media/confirmDisabled.207ce1ca399e2c077d0ce87ec0d90562.svg";
export { ForwardRef as ReactComponent };